export const CONTRACTS = {
  FACTORY: {
    97: '0x28A37a621254EEEE8b3821AE024f4CA6eD6134De',
    56: '0x1dE715416826ba17ee295E3a2D88b937885c73bd', 
    202599: '0x65Ce6c995f1BC7A56c403BEbc1701Dd0E22030c2',
    210000: '0xBDd08F47117557c20E35A50246553A25A71772a5',
    146: '0x3753F16290E52efF67578f203FeDc0B482dB30b7',
    57054: '0xa0d361690773C31AefC8cB97F48810CFB68AC4eC',
  },
  INVITATION: {
    97: '0x465258AD26432921f8c20e8bFdBC1BB273aEC7AF',
    56: '0xF5b23a86768BD4c927D1154bB169F41698154e3F',
    202599: '0xFC7b1c74cA469091D525ECAABCdF5bFb08b1b8Ab',
    210000: '0x6808728C249eff7bcb57d0e6b0B92642FE5ba5A7',
    146: '0x252cBF4BEa58922066AADa01A524234715fAE48a',
    57054: '0xFC7b1c74cA469091D525ECAABCdF5bFb08b1b8Ab',
  },
  YOLOGAME: {
    97: '0x9E76Fade8A349602A931376617C40be57590E4Fd',
    56: '0xd22114808fa7b0f31cD7D1843f8C9b65B056ADc3',
    202599: '0x465258AD26432921f8c20e8bFdBC1BB273aEC7AF',
    210000: '0x6daD66055e6d76f5F32332acB1Da969DD1503CFF',
    146: '0x45779eD02fcDbC8B5F640AF5345196000eF64769',
    57054: '0x465258AD26432921f8c20e8bFdBC1BB273aEC7AF',
  },
  YOLOTOKEN: {
    97: '0xf9811e8668B9300d7ceE4332ce2dbF7a68ab05c4',
    56: '0xB2e50F3328d0e1791FF83d70372aa4D3395778ed',
    202599: '0x30C809B746b37C6244aA097d93410Cc2eCdc34B9',
    210000: '0x4C776b12Ba20cB008eE461CeCD8Dd23d3184223D',
    146: '0x8EC05B94722bC9A7c9a65C97C4a538c193B1824b',
    57054: '0x30C809B746b37C6244aA097d93410Cc2eCdc34B9',
  },
  YOLOFOUNDATION: {
    97: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
    56: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
    202599: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
    210000: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
    146: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
    57054: '0x0D1f3feA7E5D734572971DbD258e06E0222C6f63',
  },
  ROUTER: {
    97: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    56: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    146: '0xF5F7231073b3B41c04BA655e1a7438b1a7b29c27',
    57054: '0x086D426f8B653b88a2d6D03051C8b4aB8783Be2b',
    202599: '0x6A647E09193a130b0CccBF26A1CF442491bDeCc0',
    210000: '0xa726Be96F252FbFF2732F224b2AE51CF4f05c100',

  },
  LOTTERY: {
    97: '0x9E76Fade8A349602A931376617C40be57590E4Fd',
    56: '0xb192910b536c1d579bc8c6f57ba7922977f0f5de',
    202599: '0x465258AD26432921f8c20e8bFdBC1BB273aEC7AF',
    210000: '0x6daD66055e6d76f5F32332acB1Da969DD1503CFF',
    146: '0x45779eD02fcDbC8B5F640AF5345196000eF64769',
    57054: '0x465258AD26432921f8c20e8bFdBC1BB273aEC7AF',
  },
  TOKENDISTRIBUTOR: {
    97: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
    56: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
    202599: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
    210000: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
    146: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
    57054: '0xD02f2cc060C5e850eB9C100F781E1bE5dCfaF9B6',
  },
} as const;

export const CHAIN_NATIVE_TOKEN = {
  1: 'ETH',    // Ethereum Mainnet
  56: 'BNB',   // BSC Mainnet
  97: 'BNB',   // BSC Testnet
  5: 'ETH',    // Goerli Testnet
  11155111: 'ETH', // Sepolia Testnet
  146: 'S', // Sonic Mainnet
  57054: 'S', // Sonic Testnet
  202599: 'JU', // JuChain Testnet
  210000: 'JU', // JuChain Mainnet
} as const;

export const BLOCK_EXPLORER_URL = {
  1: 'https://etherscan.io/address/',    // Ethereum Mainnet
  56: 'https://bscscan.com/address/',    // BSC Mainnet
  97: 'https://testnet.bscscan.com/address/', // BSC Testnet
  57054: 'https://testnet.sonicscan.org/address/', // Sonic Testnet
  5: 'https://goerli.etherscan.io/address/',  // Goerli Testnet
  11155111: 'https://sepolia.etherscan.io/address/', // Sepolia Testnet
  146: 'https://sonicscan.org/address/', // Sonic Mainnet
  202599: 'https://testnet.juscan.io/address/', // JuChain Testnet
  210000: 'https://juscan.io/address/', // JuChain Mainnet
} as const;

export const TRADE_URL = {
  56: 'https://pancakeswap.finance/swap?chain=bsc&outputCurrency=',    // BSC Mainnet
  97: 'https://pancakeswap.finance/swap?inputCurrency=tBNB&outputCurrency=', // BSC Testnet
  146: 'https://swapx.fi/swap?tokenIn=0x0000000000000000000000000000000000000000&tokenOut=', // Sonic Mainnet
  210000: 'https://www.jamm.trading/trade?fee=50&token1=', // JuChain Mainnet
} as const;

export const WSS_URL = {
  56: 'wss://bsc-rpc.publicnode.com',    // BSC Mainnet
  97: 'wss://bsc-testnet.drpc.org', // BSC Testnet
  146: 'wss://rpc.soniclabs.com', // Sonic Mainnet
  202599: 'ws://testnet-ws.juchain.org', // JuChain Testnet
  210000: 'wss://ws.juchain.org', // JuChain Mainnet
} as const;

export const getWSSUrl = (chainId: number) => {
  return WSS_URL[chainId as keyof typeof WSS_URL] || 'ETH';
};
export const getTradeUrl = (chainId: number) => {
  return TRADE_URL[chainId as keyof typeof TRADE_URL] || 'ETH';
};
export const getNativeToken = (chainId: number) => {
  return CHAIN_NATIVE_TOKEN[chainId as keyof typeof CHAIN_NATIVE_TOKEN] || 'ETH';
};

export const getBlockExplorerUrl = (chainId: number) => {
  return BLOCK_EXPLORER_URL[chainId as keyof typeof BLOCK_EXPLORER_URL] || 'https://etherscan.io/address/';
};

export const CURRENT_NETWORK = 'TESTNET';

export const getFactoryAddress = (chainId: number) => {
  return CONTRACTS.FACTORY[chainId as keyof typeof CONTRACTS.FACTORY] || '';
}; 
export const getInvitationAddress = (chainId: number) => {
  return CONTRACTS.INVITATION[chainId as keyof typeof CONTRACTS.INVITATION] || '';
}; 
export const getLotteryAddress = (chainId: number) => {
  return CONTRACTS.LOTTERY[chainId as keyof typeof CONTRACTS.LOTTERY] || '';
};
export const getTokenDistributorAddress = (chainId: number) => {
  return CONTRACTS.TOKENDISTRIBUTOR[chainId as keyof typeof CONTRACTS.TOKENDISTRIBUTOR] || '';
};
export const UPLOAD_URL = 'https://yoloserver.yolopadfun.workers.dev/upload-r2';